/**
Project: Voice Panel (c)
Title: Voice Route List 
Description: Component to display the list of regions and to assign and unassign the priority to the regions.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Flex, Text, Button } from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import classNames from "classnames";
import IntlUtil from "../../../../core/helpers/intl-util";
import VoiceRouteInfo from "./voice-route-info";
import { setVoiceSetupProgressPage } from "../../voice-setup/actions/voice-setup-actions";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import _ from "lodash";

class VoiceRouteList extends Component {
  _intl_ns_vpa_routing = "vpa_routing";

  loadNextPage = async () => {
    await this.props.setVoiceSetupProgressPage(
      VoiceAdminConstants.VOICE_SETUP.PROGRESS.USERS
    );
  };

  renderVoiceRoutes = () => {
    let defaultRoutePriority = -1;
    let defaultFallOverRoutePriority = -1;
    let sortedRoutes = _.orderBy(this.props.voiceRoutes, "routePriority", [
      "asc",
    ]);
    if (sortedRoutes?.length > 0)
      defaultRoutePriority = sortedRoutes[0].routePriority ?? -1;
    if (sortedRoutes?.length > 0)
      defaultFallOverRoutePriority = sortedRoutes[1].routePriority ?? -1;
    const routePriority = (route) => {
      return route.routePriority === defaultRoutePriority
        ? IntlUtil.getText(this._intl_ns_vpa_routing, "content.priority")
        : IntlUtil.getText(this._intl_ns_vpa_routing, "content.failover");
    };

    return (
      <Grid fluid className="vpa-routing-routes-grid">
        {this.props.voiceRoutes.map((route, index) => (
          <Row className="vpa-routing-routes-row" key={`vrlr-${index}`}>
            <Col
              xs={12}
              sm={12}
              md={3}
              lg={3}
              className="vpa-routing-routes-col"
            >
              <Text
                disabled={
                  route.routeStatus === 0 ||
                  this.props.selectedRoutingPolicy.policyStatus === 0
                }
                className={classNames(
                  "page-text",
                  "vpa-routing-routes-col-text",
                  {
                    "text-semibold":
                      route.routePriority === defaultRoutePriority,
                  },
                  {
                    "text-disable":
                      route.routeStatus === 0 ||
                      this.props.selectedRoutingPolicy.policyStatus === 0,
                  }
                )}
              >
                {index + 1}. {routePriority(route)}
              </Text>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={9}
              lg={9}
              className="vpa-routing-routes-col"
            >
              <VoiceRouteInfo
                voiceRoutes={this.props.voiceRoutes}
                route={route}
                selectedRoutingPolicy={this.props.selectedRoutingPolicy}
                key={`route-${index}`}
                index={index}
                history={this.props.history}
                defaultRoutePriority={defaultRoutePriority}
                defaultFallOverRoutePriority={defaultFallOverRoutePriority}
              />
            </Col>
          </Row>
        ))}
      </Grid>
    );
  };

  render() {
    return (
      <Flex column className="m-t-20">
        {this.props.selectedRoutingPolicy.policyStatus === 1 ? (
          <>
            <Flex
              column
              gap="gap.small"
              className="bg-gray p-l-15 p-r-15 p-t-10 p-b-10"
            >
              <Text className="page-text text-semibold">
                {this.props.selectedRoutingPolicy.policyId}{" "}
                {IntlUtil.getText(this._intl_ns_vpa_routing, "content.regions")}
              </Text>
              <Flex column className="vpa-routing-routes m-t-0">
                {this.renderVoiceRoutes()}
              </Flex>
            </Flex>
          </>
        ) : null}
        <Flex gap="gap.small" className="m-t-20">
          {this.props.selectedRoutingPolicy.policyStatus === 1 ? (
            <Button
              primary
              className="vpa-voice-setup-button m-l-5 m-r-20"
              content={IntlUtil.getText(
                this._intl_ns_vpa_routing,
                "content.applyChanges"
              )}
              onClick={() => this.props.updateVoiceRoutes()}
              disabled={
                this.props.selectedRoutingPolicy.policyStatus === 0 ||
                this.props.voiceRoutesUpdateButtonDisableStatus === true
              }
            />
          ) : null}
          {this.props.voiceSetupProgressPage &&
          this.props.voiceSetupProgressPage ===
            VoiceAdminConstants.VOICE_SETUP.PROGRESS.ROUTING ? (
            <Button
              primary
              content={IntlUtil.getText(
                this._intl_ns_vpa_routing,
                "content.continueSetup"
              )}
              onClick={this.loadNextPage}
              className="vpa-voice-setup-button"
            />
          ) : null}
        </Flex>
      </Flex>
    );
  }
}

const mapStateToProps = (state) => ({
  voiceRoutesUpdateButtonDisableStatus:
    state.routingStore.voiceRoutesUpdateButtonDisableStatus,
  voiceSetupProgressPage: state.voiceSetupStore.voiceSetupProgressPage,
});

const mapActionToProps = {
  setVoiceSetupProgressPage,
};

export default connect(mapStateToProps, mapActionToProps)(VoiceRouteList);
